/**
 * @flow
 * @relayHash aef6035b48d5eb3ee1164bf498cfbb75
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeliverableState = "A_1" | "A_2" | "A_3" | "A_4" | "A_5" | "A_6" | "A_7" | "A_8" | "A_9" | "%future added value";
export type CancelDeliverableInput = {|
  id: string,
  clientMutationId?: ?string,
|};
export type CancelDeliverableMutationVariables = {|
  input: CancelDeliverableInput
|};
export type CancelDeliverableMutationResponse = {|
  +cancelDeliverable: ?{|
    +updatedDeliverable: ?{|
      +state: DeliverableState
    |}
  |}
|};
export type CancelDeliverableMutation = {|
  variables: CancelDeliverableMutationVariables,
  response: CancelDeliverableMutationResponse,
|};
*/


/*
mutation CancelDeliverableMutation(
  $input: CancelDeliverableInput!
) {
  cancelDeliverable(input: $input) {
    updatedDeliverable {
      state
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CancelDeliverableInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "state",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CancelDeliverableMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cancelDeliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CancelDeliverablePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedDeliverable",
            "storageKey": null,
            "args": null,
            "concreteType": "DeliverableNode",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CancelDeliverableMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cancelDeliverable",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "CancelDeliverablePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "updatedDeliverable",
            "storageKey": null,
            "args": null,
            "concreteType": "DeliverableNode",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "CancelDeliverableMutation",
    "id": null,
    "text": "mutation CancelDeliverableMutation(\n  $input: CancelDeliverableInput!\n) {\n  cancelDeliverable(input: $input) {\n    updatedDeliverable {\n      state\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1e21f66b3c2845f3e9d7d62b348a9b5e';
module.exports = node;
